export default function PersonSVG({ ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...rest}
    >
      <path
        d="M13.3334 14.6665H2.66669V13.3332C2.66669 11.4922 4.15907 9.99984 6.00002 9.99984H10C11.841 9.99984 13.3334 11.4922 13.3334 13.3332V14.6665ZM8.00002 8.6665C5.79088 8.6665 4.00002 6.87564 4.00002 4.6665C4.00002 2.45736 5.79088 0.666504 8.00002 0.666504C10.2092 0.666504 12 2.45736 12 4.6665C12 6.87564 10.2092 8.6665 8.00002 8.6665Z"
        fill="#042675"
      />
    </svg>
  );
}
